import React from 'react';
import { PriceBreakdownWrapper } from './PriceBreakdownWrapper';

interface LeisureBreakdownProps {
  priceItems: any[];
  currency: string;
  eurPrices?: any[];
}

export function LeisureBreakdown({ priceItems, currency, eurPrices }: LeisureBreakdownProps) {
  const LEISURE_ITEMS = [
    { id: 40, name: 'Abonnement mensuel salle de sport' },
    { id: 44, name: 'Place de cinéma' },
    { id: 6, name: 'Cappuccino en café' },
    { id: 7, name: 'Bière en bar' }
  ];

  const getItemPrice = (itemId: number) => {
    const item = priceItems.find(item => item.item_id === itemId);
    const eurItem = eurPrices?.find(item => item.item_id === itemId);
    
    if (!item) return null;

    return {
      price: item.average_price,
      eurPrice: eurItem?.average_price
    };
  };

  return (
    <PriceBreakdownWrapper title="Prix moyens constatés pour vous aider à estimer votre budget loisirs">
      <div className="space-y-2">
        {LEISURE_ITEMS.map(item => {
          const prices = getItemPrice(item.id);
          if (!prices) return null;

          return (
            <div key={item.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-2 border-b border-gray-200/50 dark:border-gray-700/50 last:border-0">
              <span className="text-sm text-gray-600 dark:text-gray-400 mb-1 sm:mb-0">
                {item.name}
              </span>
              <div className="text-right font-mono text-base sm:text-sm font-medium text-primary-600 dark:text-primary-400">
                {(prices.eurPrice || prices.price).toFixed(2)} €
              </div>
            </div>
          );
        })}

        {/* Note explicative */}
        <div className="mt-6 pt-4 border-t-2 border-gray-200 dark:border-gray-600">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Ces prix sont donnés à titre indicatif. Votre budget loisirs dépendra de vos habitudes et des activités que vous souhaitez pratiquer.
          </p>
        </div>
      </div>
    </PriceBreakdownWrapper>
  );
}